<template>
  <div class="container lms-wrapper">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyWorker' }" class="tx-11" style="color: #444">Buddy ажилтан</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Шинэ ажилтан</li>
              </ol>
            </nav>
            <div class="mg-l-auto">
              <div class="tggler d-flex" v-if="newbieRdy">
                <div :class="`${newbie.isActive?'actv':''} pd-x-40 pd-y-10`">Одоо идэвхтэй</div>
                <div :class="`${!newbie.isActive?'actv':''} pd-x-40 pd-y-10`">Дууссан</div>
              </div>
            </div>
          </div>

          <!-- <my-buddy v-if="newbieRdy"  :propObj="newbie" :propRdy="true" title="`Миний Buddy-лж буй ажилтан`"></my-buddy> -->
          
          <checklist v-if="rdy" cardTitle="Туршилтын ажилтан" :userTaskId="$route.params.id" @on-user-info="onUserInfo"></checklist>
        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="dropdown-menu dropdown-menu-right tx-13 divide-y">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    myBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/myBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    checklist: () => ({
      component: import("@/views/modules/lms/student/buddy/components/checklist.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      newbieRdy: false,
      rdy: false,
      newbie:{},
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    onUserInfo(){

    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
          rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      this.rdy= true;
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // request({
      //     api: { method: "POST", url: "buddy/admin/getNewbies" },
      //     data: {
      //       filter: {
      //         id: this.$route.params.id,
      //       }
      //     },
      //     store: this.$store,
      // }).then((res) => {
      //     this.loading= false;
      //     this.toggleBodyClass("removeClass", "dynamic-locker");
      //     if(res!=false){
      //       if(res.data.list.length){
      //         this.newbie= res.data.list[0];
      //         this.newbieRdy= true;
      //       }
      //       // console.log('res buddy/admin/getNewbies', res.data.list);
      //     }
      // });
    },
    
  },
};
</script>
<style lang="scss">
.tggler{
  background: #D7D7D7;
  border-radius: 20px;
  div{
    font-weight: 500;
    &.actv{
      background: linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);
      border-radius: 20px;
      color: white;
    }
  }
}
</style>